import React, { useEffect, useRef, useState } from "react";
import CircularProgressBar from "../../../../components/CircularProgressBar/CircularProgressBar";

interface AnimatedCircularProps {
  percent: number;
}

const AnimatedCircular: React.FC<AnimatedCircularProps> = ({ percent }) => {
  const [animatedPercent, setAnimatedPercent] = useState(0);
  const circleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let observer: IntersectionObserver | null = null;

    if (circleRef.current) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            let start = 0;
            const duration = 1000; // animation duration in ms
            const increment = percent / (duration / 10);

            const interval = setInterval(() => {
              start += increment;
              if (start >= percent) {
                start = percent;
                clearInterval(interval);
              }
              setAnimatedPercent(Math.round(start));
            }, 10);

            // stop observing after first animation
            if (observer && circleRef.current) {
              observer.unobserve(circleRef.current);
              observer.disconnect();
            }
          }
        },
        { threshold: 0.3 }, // trigger when 30% visible
      );

      observer.observe(circleRef.current);
    }

    return () => {
      if (observer) observer.disconnect();
    };
  }, [percent]);

  return (
    <div ref={circleRef}>
      <CircularProgressBar percent={animatedPercent} />
    </div>
  );
};

export default AnimatedCircular;
